/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';

import mbpLogger from 'mbp-logger';
import withWidth from '@material-ui/core/withWidth';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// API Calls
import getDeliveryCalendarByProduct from '../../../../../../../../apis/product-apis/getDeliveryCalendarByProduct';

// Checkout UI
import CalendarView from './Partials/CalendarBuilder/CalendarView';
import CloseCalendarConsent from './Partials/CloseCalendarConsent/CloseCalendarConsent';
import ErrorMessage from '../../ErrorMessage/ErrorMessage';
import ExactDay from './Partials/ExactDay/ExactDay';
import FoodArrivalDetails from './Partials/FoodArrivalDetails/FoodArrivalDetails';
import MonthDatedCalendarView from './Partials/CalendarBuilder/MonthDatedCalendarView';
import ShipHolidaysList from './Partials/ShipHolidaysList/ShipHolidaysList';
import WeekDatedCalendarView from './Partials/CalendarBuilder/WeekDatedCalendarView';

import { withAuth } from '../../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

// Member
import {
    getShopRunnerToken,
    getIsPassportUserLoggedIn,
} from '../../../../../../../../state/ducks/Checkout/ducks/Global/Global-Selectors';

// Checkout
import * as commonSelectors from '../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import * as CalendarUtility from './Partials/CalendarBuilder/helpers/calendarUtility';
import {
    getPassportSubscriptionStatus,
} from '../../../../../../../../state/ducks/MfeCheckout/ducks/Cart/Cart-Selectors';
import cartServiceClient  from '../../../../../../../../apis/cart-service-apis';

const styles = (theme) => ({
    deliveryCalendarDialogRoot: {
        bottom: 'auto !important',
        top: '5px !important',
        [theme.breakpoints.down(670)]: {
            top: '0 !important',
        },
    },
    deliveryCalendarDialogPaper: {
        borderRadius: '0px',
        marginTop: '0px',
        minHeight: '320px',
        maxHeight: 'calc(100vh - 25px)',
        maxWidth: '670px',
        width: '100%',
        [theme.breakpoints.down(670)]: {
            height: '100vh',
            maxHeight: '100vh',
        },
        // '@media (max-height: 780px)': {
        //     height: 'calc(100vh - 25px)',
        // },
    },
    dialogHeader: {
        backgroundColor: '#F8F8F8',
        height: '40px',
        textAlign: 'right',
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 1,
    },
    dialogCloseIcon: {
        color: '#000',
        margin: 0,
        padding: '7px',
    },
    calendarContainer: {
        padding: '0 57px 28px',
        [theme.breakpoints.down(670)]: {
            padding: '0 25px 20px',
            minHeight: 'calc(100vh - 122px)',
        },
        [theme.breakpoints.down(408)]: {
            padding: '10px',
        },
    },
    containerTopCalendar: {
        borderBottom: '1px solid #E9E9E9',
    },
    weeklyMonthlyHeader: {
        padding: '24px 0px',
        textAlign: 'center',
        borderBottom: '1px solid #E9E9E9',
        marginBottom: '24px',
        [theme.breakpoints.down(626)]: {
            padding: '16px 0px',
            marginBottom: '16px',
        },
        [theme.breakpoints.down(500)]: {
            fontSize: '0.8em',
            lineHeight: '1.1em',
        },
    },
    dayOfTheWeek: {
        border: '1px solid #E9E9E9',
        margin: '0',
        lineHeight: '1em',
        [theme.breakpoints.down(520)]: {
            border: 0,
        },
    },
    holidayBtnStyle: {
        backgroundColor: theme.palette.background?.paper,
    },
    selectedUpChargeBtn: {
        backgroundColor: '#DEEFE6 !important',
        '& button': {
            padding: '0',
            color: '#2F2F2F',
            borderRadius: '0',
            width: '100%',
            fontSize: '0.88em',
            display: 'block',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
        '&>p': {
            border: 0,
        },
    },
    selectedFreeBtn: {
        backgroundColor: '#DEEFE6 !important',
        '& button': {
            padding: '0',
            color: '#2F2F2F',
            borderRadius: '0',
            width: '100%',
            fontSize: '0.88em',
            display: 'block',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
        '&>p': {
            border: 0,
        },
    },
    selectedBtn: {
        backgroundColor: '#DEEFE6 !important',
        '& button': {
            color: '#2F2F2F !important',
            borderRadius: '0',
            width: '100%',
            fontSize: '0.88em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
        '& > p': {
            border: '1px solid #DEEFE6',
        },
    },
    unselectedBtn: {
        '& button': {
            borderRadius: '0',
            color: '#2F2F2F',
            width: '100%',
            fontSize: '0.88em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
        '&:hover, &:visited, &:active, &:focus': {
            backgroundColor: '#DEEFE6',
            '& > p': {
                border: '1px solid #DEEFE6',
            },
        },
    },
    disabledHover: {
        '&:hover, &:visited, &:active, &:focus': {
            backgroundColor: '#fff',
            '& > p': {
                border: '1px solid #E9E9E9',
            },
        },
    },
    disabledBtn: {
        borderRadius: '0',
        width: '100%',
        fontSize: '0.88em',
        display: 'block',
        padding: '0',
        minWidth: 'initial',
        color: '#C4C4C4 !important',
        maxHeight: '46px',
        height: '46px',
        fontWeight: 'bold',
        lineHeight: '1em',
        '&:hover, &:visited, &:active, &:focus': {
            backgroundColor: '#fff',
            '& > p': {
                border: '1px solid #DEEFE6',
            },
        },
    },
    upChargeBtn: {
        '& button': {
            width: '100%',
            borderRadius: 0,
            color: '#2F2F2F',
            fontSize: '0.88em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
    },
    freeDelivery: {
        '& button': {
            width: '100%',
            borderRadius: 0,
            color: '#2F2F2F',
            fontSize: '0.88em',
            display: 'block',
            padding: '0',
            minWidth: 'initial',
            height: '46px',
            maxHeight: '46px',
            fontWeight: 'bold',
            lineHeight: '1em',
            '&:hover, &:visited, &:active, &:focus': {
                backgroundColor: '#DEEFE6',
            },
        },
    },
    firstSelectedBtn: {
        paddingLeft: 0,
        marginLeft: '4px',
    },
    lastSelectedBtn: {
        paddingRight: 0,
        marginRight: '4px',
    },
    pricePerDay: {
        fontSize: '0.76em',
        color: '#2F2F2F',
        display: 'block',
        fontWeight: 'normal',
    },
    pricePerDaySelected: {
        fontSize: '0.76em',
        color: '#2F2F2F',
        display: 'block',
        fontWeight: 'normal',
    },
    chargeTextStyle: {
        textTransform: 'none',
    },
    calendarLoader: {
        width: '100%',
        textAlign: 'center',
        padding: '100px 0px',
    },
    gridStyle: {
        padding: '0px',
        width: '100%',
        '& li': {
            paddingTop: '0px',
        },
    },
    gridStylePadding: {
        padding: '0',
    },
    monthlyWeeklyText: {
        fontSize: '1em',
    },
    prevButton: {
        fontFamily: theme.typography.fontFamily,
        fontSize: '1em',
        fontWeight: '500',
        color: theme.palette.primary.main,
        textDecoration: 'underline',
        textTransform: 'none',
        '&:hover, &:focus, &:active': {
            backgroundColor: 'transparent',
            color: theme.palette.primary.main,
            textDecoration: 'underline',
        },
    },
    errorInfo: {
        margin: '130px 0',
        justifyContent: 'center',
        alignContent: 'center',
        '& p': {
            textAlign: 'center',
        },
    },
});

class DeliveryFoodCalendarV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: '',
            endDate: '',
            selectedDateRange: [],
            selectedDeliveryDate: {},
            calendarResponse: {},
            forceExactDay: false,
            calendarDisplayData: {},
            showLoader: false,
            selectedHoliday: {},
            shipHolidayDetails: {},
            selectedDateAnHoliday: false,
            holidaySelected: 'Choose Holiday',
            monthDatedData: [],
            weekDatedData: [],
            activeMonth: '',
            activeWeek: '',
            errorMessage: null,
        };
        this.deliveryDate = [];
        this.selectedDate = '';
        this.savedDateHoliday = '';
        this.selectedDateType = '';
        this.holidayDateCollection = [];
    }

    componentDidMount = () => {
        this.initCalendar();
    }

    handleDeliveryResponse(response, detailsForDate) {
        if (response.data) {
            if (response.data.response.deliveryIndicator === 'MO') {
                this.handleDeliveryMonthResponse(response);
            } else if (response.data.response.deliveryIndicator === 'WO') {
                this.handleDeliveryWeekResponse(response);
            } else {
                this.handleDeliveryDateResponse(response, detailsForDate);
            }
        } else {
            const err = new Error('Response Error');
            err.response = {
                data: {
                    response: 'Error',
                    detailedError: {
                        errorKey: 'No Date are available',
                        errorMessage: 'No Date are available',
                        detailedErrorMessage: 'No Date are available',
                        validationErrors: [],
                    },
                },
            };

            throw err;
        }
    }

    onChangeForceExactDay = (event) => {
        const isChecked = event.target.checked;
        const { selectedDeliveryDate, calendarResponse } = this.state;
        let { selectedDateRange } = this.state;
        if (isChecked && selectedDeliveryDate.calendarDateType === 'between') {
            selectedDateRange = [];
            selectedDateRange.push(selectedDeliveryDate.deliveryDate);
        } else if (!isChecked && selectedDeliveryDate.calendarDateType === 'between') {
            const rangeStartDate = CalendarUtility.convertToDateObj(selectedDeliveryDate.rangeStartDate);
            const rangeEndDate = CalendarUtility.convertToDateObj(selectedDeliveryDate.deliveryDate);
            selectedDateRange = CalendarUtility.getDateStringBtn(rangeStartDate, rangeEndDate).map((date) => (
                CalendarUtility.convertDateObjToDateStr(date)
            ));
        }
        if (isChecked && Object.prototype.hasOwnProperty.call(calendarResponse, 'guaranteedCharge')) {
            selectedDeliveryDate.guaranteedChargeToApply = calendarResponse.guaranteedCharge;
            this.setState({ selectedDeliveryDate });
        }

        this.setState({
            selectedDateRange,
            forceExactDay: isChecked,
            holidaySelected: 'Choose Holiday',
            selectedDateAnHoliday: false,
        });
    }

    checkWidth = () => {
        const { width } = this.props;
        const widthObj = {
            desktop: false,
            mobile: false,
        };
        switch (width) {
            case 'md':
            case 'lg':
                widthObj.desktop = true;
                break;
            case 'sm':
            case 'xs':
                widthObj.mobile = true;
                break;
            default:
                break;
        }
        return widthObj;
    };

    onHolidaySelected = (selVal) => {
        const { shipHolidayDetails } = this.state;
        this.setState({
            holidaySelected: selVal,
            selectedDateAnHoliday: false,
        });
        if (selVal !== 'Choose Holiday') {
            const holidayDetails = shipHolidayDetails[selVal][0];
            let holidayDateStart = '';

            const tempholidayDate = holidayDetails.holidayDate.split(' ')[0];
            const arrholidayDate = tempholidayDate.split('-');
            holidayDateStart = `${arrholidayDate[0]}-${arrholidayDate[1]}-01`;
            this.getDeliveryResponse(holidayDateStart);
            this.updateSelectedHoliday(holidayDetails);
        } else {
            this.updateSelectedHoliday({});
        }
    }

    onSelectedDate = (date) => {
        const selDate = CalendarUtility.convertDateObjToDateStr(date);
        const selDateProps = this.deliveryDate[selDate];

        if (selDateProps) {
            this.setState((prevState) => ({
                ...prevState,
                holidaySelected: selDateProps[0]?.holidayCode?.[0] || 'Choose Holiday',
                selectedDateAnHoliday: !!selDateProps[0]?.holidayCode?.[0],
            }), () => {
                const updateSelectedDateDetails = this.getSelectedDateDetails(selDateProps, date, false);
                this.setState({
                    ...updateSelectedDateDetails,
                });
            });
        }
    }

    getShippingType = () => {
        let shippingType = 'Standard';
        const { shopRunnerLoggedIn, isPassportUser, passportSubscriptionStatus } = this.props;
        if (shopRunnerLoggedIn) {
            shippingType = 'ShopRunner';
        }
        if (isPassportUser || passportSubscriptionStatus) {
            shippingType = 'Passport';
        }
        return shippingType;
    }

    getIfHolidayDateSelected = () => {
        const { holidaySelected } = this.state;
        // eslint-disable-next-line no-unneeded-ternary
        return (holidaySelected !== 'Choose Holiday' && holidaySelected !== '') ? true : false;
    }

    getSelectedDateDetails = (selDateDetailsProps, dateObj, savedDateHoldiayDate = false, selectedDateType = '') => {
        const { forceExactDay } = this.state;
        const { flags } = this.props;
        const calendarResponse = this.response;
        const isHolidaySelected = this.getIfHolidayDateSelected();
        const selDateProps = selDateDetailsProps[0];
        selDateProps.dateObj = dateObj;
        const { holidayCode, holidayStartDate } = selDateProps;
        let selectedDateRange = [];

        if (flags['is-calendar-date-type-by-enabled'] && selDateProps.calendarDateType === 'by') {
            selectedDateRange.push(selDateProps.deliveryDate);
        } else if (selDateProps.calendarDateType === 'on' || (selectedDateType === 'on' && selDateProps.calendarDateType === 'between') || (forceExactDay === true && selDateProps.calendarDateType === 'between')) {
            selectedDateRange.push(selDateProps.deliveryDate);
        } else if (selDateProps.calendarDateType === 'between') {
            const deliveryDate = CalendarUtility.convertToDateObj(selDateProps.deliveryDate);
            const rangeStartDate = (holidayCode && holidayStartDate && (isHolidaySelected || savedDateHoldiayDate)) ? CalendarUtility.convertToDateObj(holidayStartDate) : CalendarUtility.convertToDateObj(selDateProps.rangeStartDate);
            selectedDateRange = CalendarUtility.getDateStringBtn(rangeStartDate, deliveryDate).map((date) => (
                CalendarUtility.convertDateObjToDateStr(date)
            ));
        }

        if (Object.prototype.hasOwnProperty.call(calendarResponse, 'guaranteedCharge')) {
            selDateProps.guaranteedChargeToApply = calendarResponse.guaranteedCharge;
        }

        const updateforceExactDay = (this.selectedDateType === 'on' && selDateProps.calendarDateType === 'between') ? true : forceExactDay;

        return {
            selectedDateRange,
            selectedDeliveryDate: selDateProps,
            forceExactDay: updateforceExactDay,
        };
    }

    getDeliveryResponse = async (detailsForDate) => {
        const {
            updateShowLoadingMessage, orderItemId, orderItem,
            flagOffShowLoadingMessage, orderId, flags, zipCode,
            auth,
        } = this.props;
        const { errorMessage } = this.state;
        const jwtToken = await auth.getAccessTokenSafely();
        updateShowLoadingMessage();

        // Clear All Errors
        if (errorMessage) {
            this.setState({ errorMessage: '' });
        }

        if (
            flags['which-calendar-variation'] === 'availability'
            && orderItem
            && orderItem.product?.productCode
            && orderItem.product?.brandCode
            && zipCode
        ) {
            // Starting at the end of the string (backwards pattern matching), continue to match any characters that aren't '-' or '_'
            const skuProductCode = orderItem.product.productCode.match(/[^-_]*$/);
            const brandCode = orderItem.product.brandCode;
            const recipientZipCode = zipCode.split('-')[0];
            const locationType = orderItem.deliveryInfo.locationType || 'Residence';

            getDeliveryCalendarByProduct(
                {},
                jwtToken,
                skuProductCode,
                brandCode,
                recipientZipCode,
                locationType,
                detailsForDate,
            )
                .then((response) => this.handleDeliveryResponse(response, detailsForDate))
                .catch((err) => {
                    flagOffShowLoadingMessage();
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        function: 'getDeliveryCalendarByProduct',
                        message: 'getDeliveryCalendarByProduct -- Error calling Calendar API',
                        jsError: err,
                    });

                    this.setState({ errorMessage: err.response.data.errorMessage });
                });
        } else if (flags['which-calendar-variation'] === 'cart') {
            const payload = {
                env: {},
                jwtToken,
                cartId: orderId,
                cartItemId: orderItemId,
                startDate: detailsForDate,
            };
            cartServiceClient.displayCalendar(payload)
                .then((response) => this.handleDeliveryResponse(response, detailsForDate))
                .catch((err) => {
                    flagOffShowLoadingMessage();
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        function: 'displayCalendar',
                        message: 'displayCalendar -- Error calling Calendar API',
                        jsError: err,
                    });

                    this.setState({ errorMessage: err.response.data.errorMessage });
                });
        }
    }

    getLastDateFromCalendarView = (dateCollection) => {
        const year = Object.keys(dateCollection);
        const month = Object.keys(dateCollection[year[year.length - 1]]);
        const weeks = Object.keys(dateCollection[year[year.length - 1]][month[month.length - 1]]);
        const lastCalendarWeekCollection = dateCollection[year[year.length - 1]][month[month.length - 1]][weeks[weeks.length - 1]];
        const lastDateKey = Object.keys(lastCalendarWeekCollection)[Object.keys(lastCalendarWeekCollection).length - 1];
        const lastDate = lastCalendarWeekCollection[lastDateKey];
        return lastDate;
    }

    getHolidayDeliveryDate = (holidayCode, calendarDates) => {
        const [holidayDateDetails] = calendarDates.filter((dateObj) => {
            // Handle Array Type for holidaycode - ["CH", "NW"]
            // And String Type for holidaycode - "CH"
            if (dateObj?.holidayCode && Array.isArray(dateObj.holidayCode) && dateObj.holidayCode.includes(holidayCode)) {
                return dateObj;
            } if (dateObj?.holidayCode === holidayCode) {
                return dateObj;
            }
            return '';
        });
        if (holidayDateDetails && holidayDateDetails.deliveryDate) {
            return holidayDateDetails.deliveryDate;
        }
        return '';
    }

    getButtonStyleForBrandSpecific = (brand, classes) => ({
        selectedBtn: classes.selectedBtn,
        selectedUpChargeBtn: classes.selectedUpChargeBtn,
        upChargeBtn: classes.upChargeBtn,
    })

    getSelectedMonthDetails = (newDate, calendarDateType, deliverySLA) => {
        this.setState({
            selectedDeliveryDate: {
                calendarDateType,
                deliverySLA,
                rangeStartDate: newDate,
                deliveryDate: newDate,
            },
            activeMonth: newDate,
        });
    };

    getSelectedWeekDetails = (newDate, calendarDateType, deliverySLA, weekOfCode) => {
        this.setState({
            selectedDeliveryDate: {
                calendarDateType,
                deliverySLA,
                weekOfCode,
                rangeStartDate: newDate,
                deliveryDate: newDate,
            },
            activeWeek: newDate,
        });
    };

    updateSelectedHoliday = (selHoliday) => {
        this.setState({
            selectedHoliday: selHoliday,
            selectedDateAnHoliday: false,
        });
    }

    getSavedDateHolidayCode = () => {
        const { orderItem } = this.props;

        return orderItem?.deliveryInfo?.holidayCode || '';
    }

    handleDeliveryDateResponse = (response, detailsForDate) => {
        const dataDeliveryCalendar = response.data.response;
        const calendarDates = dataDeliveryCalendar?.calendarDates || [];
        const shipHolidays = dataDeliveryCalendar.shipHolidays || [];
        this.response = dataDeliveryCalendar;
        const { flagOffShowLoadingMessage } = this.props;
        const calendarDatesLength = calendarDates.length;

        if (calendarDatesLength > 0) {
            if (this.state.forceExactDay) {
                const isShowExactDay = (
                    dataDeliveryCalendar.calendarDateType === 'between'
                    && dataDeliveryCalendar.guaranteedCharge && dataDeliveryCalendar.guaranteedCharge !== 'null'
                );

                if (!isShowExactDay) {
                    this.setState({ forceExactDay: false });
                }
            }

            // Delivery Calendar Dates
            this.deliveryDate = CalendarUtility.getDeliveryDates(calendarDates);
            const collectionOfHolidayByHolidayCode = CalendarUtility.getHolidayDates(shipHolidays);

            const firstDateFrmResp = calendarDates[0].deliveryDate;
            const lastDateFrmResp = calendarDates[calendarDatesLength - 1].deliveryDate;

            // Round Dates
            const roundDateParaStartDate = CalendarUtility.convertToDateObj(firstDateFrmResp);
            const roundDateParaEndDate = CalendarUtility.convertToDateObj(lastDateFrmResp);
            const roundedDates = CalendarUtility.roundDateCalendarStartAndEndDate(roundDateParaStartDate, roundDateParaEndDate);

            // Date Range Selection Start
            let selDateProps = '';
            const { selectedHoliday } = this.state;
            let isSelectedDateAnHoliday = false;

            let selectHolidayCode = 'Choose Holiday';
            this.holidayDateCollection = shipHolidays.map((itemHolidayDetails) => itemHolidayDetails.holidayDate.split(' ')[0]);
            const selectedDateHoliday = shipHolidays.filter((itemHolidayDetails) => itemHolidayDetails.holidayDate.split(' ')[0] === this.selectedDate);

            if (this.savedDateHoliday || selectedHoliday?.holidayDate || selectedDateHoliday?.length > 0) {
                isSelectedDateAnHoliday = true;
                selectHolidayCode = selectedHoliday?.holidayCode || selectedDateHoliday?.[0]?.holidayCode || this.savedDateHoliday;
                this.selectedDate = this.getHolidayDeliveryDate(selectHolidayCode, calendarDates);
            }

            selDateProps = this.deliveryDate[this.selectedDate];

            if (selDateProps) {
                const selDateObj = CalendarUtility.convertToDateObj(this.selectedDate);
                const updateSelectedDateDetails = this.getSelectedDateDetails(selDateProps, selDateObj, isSelectedDateAnHoliday, this.selectedDateType);
                this.setState(updateSelectedDateDetails);
            }
            // Date Range Selection End
            const objStartDate = roundedDates.startDate;
            const objEndDate = roundedDates.endDate;
            const calendarViewData = CalendarUtility.getDaysBreakDown(objStartDate, objEndDate);
            const calendarEndDate = this.getLastDateFromCalendarView(calendarViewData);

            this.setState({
                startDate: objStartDate,
                endDate: calendarEndDate.dateObj,
                calendarResponse: dataDeliveryCalendar,
                calendarDisplayData: calendarViewData,
                showLoader: false,
                shipHolidayDetails: collectionOfHolidayByHolidayCode,
                selectedDateAnHoliday: isSelectedDateAnHoliday,
                holidaySelected: selectHolidayCode,
            });

            this.selectedDateType = '';
            flagOffShowLoadingMessage();
        } else {
            this.deliveryDate = [];
            const objDetailsFor = CalendarUtility.convertToDateObj(detailsForDate);
            const objStartDate = new Date(objDetailsFor.getFullYear(), objDetailsFor.getMonth(), 1);
            const objEndDate = new Date(objStartDate.getFullYear(), objStartDate.getMonth() + 1, 0);

            const calendarViewData = CalendarUtility.getDaysBreakDown(objStartDate, objEndDate);
            const calendarEndDate = this.getLastDateFromCalendarView(calendarViewData);

            this.setState({
                startDate: objStartDate,
                endDate: calendarEndDate.dateObj,
                calendarResponse: {
                    calendarDates: [],
                    deliveryIndicator: '-',
                    guaranteedCharge: 'null',
                    guaranteedMethod: 'null',
                    shipHolidays: [],
                    holidaySelected: 'Choose Holiday',
                },
                calendarDisplayData: calendarViewData,
                showLoader: false,
                shipHolidayDetails: {},
                selectedDateAnHoliday: false,
                forceExactDay: false,
            });

            this.holidayDateCollection = [];
            this.selectedDateType = '';
            flagOffShowLoadingMessage();
        }
    }

    handleDeliveryMonthResponse = (response) => {
        const { flagOffShowLoadingMessage, selectedDate, orderItem } = this.props;
        const dataDeliveryCalendar = response.data.response;
        const { calendarDates } = dataDeliveryCalendar;
        this.response = dataDeliveryCalendar;
        if (calendarDates.length > 0) {
            const monthDatedData = [];
            calendarDates.forEach((mnth) => {
                const fullDate = new Date(mnth.deliveryDate);
                const { calendarDateType, deliverySLA  } = mnth;
                monthDatedData.push({
                    day: fullDate.getDate(),
                    month: fullDate.getMonth(),
                    year: fullDate.getFullYear(),
                    calendarDateType,
                    deliverySLA,
                });
            });
            const isMonthDatedCalendar = dataDeliveryCalendar?.deliveryIndicator === 'MO';
            this.setState({
                isMonthDatedCalendar,
                monthDatedData,
                activeMonth: selectedDate,
                selectedDeliveryDate: {
                    calendarDateType: orderItem?.deliveryInfo?.deliveryDateType,
                    deliverySLA: orderItem?.deliveryInfo?.deliverySLA,
                    rangeStartDate: orderItem?.deliveryInfo?.deliveryRangeStartDate,
                    deliveryDate: selectedDate,
                },
            });

            flagOffShowLoadingMessage();
        }
    }

    handleDeliveryWeekResponse = (response) => {
        const { selectedDate, orderItem, flagOffShowLoadingMessage } = this.props;
        const dataDeliveryCalendar = response.data.response;
        const { calendarDates } = dataDeliveryCalendar;
        this.response = dataDeliveryCalendar;
        if (calendarDates.length > 0) {
            const weekDatedData = [];
            calendarDates.forEach((week) => {
                const fullDate = new Date(week.deliveryDate);
                const { calendarDateType, deliverySLA, weekOfCode } = week;
                weekDatedData.push({
                    month: fullDate.getMonth(),
                    date: fullDate.getDate(),
                    year: fullDate.getFullYear(),
                    calendarDateType,
                    deliverySLA,
                    weekOfCode,
                });
            });
            const isWeekDatedCalendar = dataDeliveryCalendar?.deliveryIndicator === 'WO';
            this.setState({
                isWeekDatedCalendar,
                weekDatedData,
                activeWeek: selectedDate,
                selectedDeliveryDate: {
                    calendarDateType: orderItem?.deliveryInfo?.deliveryDateType,
                    deliverySLA: orderItem?.deliveryInfo?.deliverySLA,
                    rangeStartDate: orderItem?.deliveryInfo?.deliveryRangeStartDate,
                    deliveryDate: selectedDate,
                },
            });
            flagOffShowLoadingMessage();
        }
    }

    initCalendar = () => {
        const { selectedDate, orderItem, flags } = this.props;
        const tempDate = selectedDate.split('-');
        let getResponseFor = `${tempDate[0]}-${CalendarUtility.addLeadingZero(tempDate[1])}-01`;
        if (flags['is-calendar-anchor-by-current-date']) {
            getResponseFor = CalendarUtility.convertDateObjToDateStr(CalendarUtility.getCurrentDate());
        }
        const selectedDeliveryDate = `${tempDate[0]}-${CalendarUtility.addLeadingZero(tempDate[1])}-${CalendarUtility.addLeadingZero(tempDate[2])}`;
        this.selectedDate = selectedDeliveryDate;
        this.savedDateHoliday = this.getSavedDateHolidayCode();
        this.selectedDateType = orderItem?.dateType || '';

        this.getDeliveryResponse(getResponseFor);
    }

    calNextCallBack = () => {
        this.setState({
            showLoader: true,
        });
        let nextDate = '';
        const { endDate } = this.state;
        const lastDateOfTheMonthOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
        if (lastDateOfTheMonthOfEndDate.getTime() === endDate.getTime()) {
            const objTempDate = new Date(endDate);
            objTempDate.setDate(1);
            // The date is reset to 1 before the month is changed to prevent skipping months.
            // When going from months with 31 days to 30.
            objTempDate.setMonth(objTempDate.getMonth() + 1);
            const objNextMonthStartDate = new Date(objTempDate.getFullYear(), objTempDate.getMonth(), 1);
            nextDate = CalendarUtility.convertDateObjToDateStr(objNextMonthStartDate);
        } else {
            const objTempDate = new Date(endDate);
            objTempDate.setDate(1);
            nextDate = CalendarUtility.convertDateObjToDateStr(objTempDate);
        }
        this.getDeliveryResponse(nextDate);
    }

    callGoBackCallBack = () => {
        this.setState({
            showLoader: true,
        });
        const { endDate } = this.state;
        const firstDateOfLastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
        const strPrevMonthStartDate  = CalendarUtility.convertDateObjToDateStr(firstDateOfLastMonth);
        this.getDeliveryResponse(strPrevMonthStartDate);
    }

    calPrevCallBack = () => {
        this.setState({
            showLoader: true,
        });
        const { startDate } = this.state;
        const objTempDate = new Date(startDate);
        objTempDate.setMonth(objTempDate.getMonth() - 1);
        const objPrevMonthStartDate = new Date(objTempDate.getFullYear(), objTempDate.getMonth(), 1);
        const strPrevMonthStartDate = CalendarUtility.convertDateObjToDateStr(objPrevMonthStartDate);
        this.getDeliveryResponse(strPrevMonthStartDate);
    }

    monthlyWeeklyCalendarNotice = () => {
        const { classes } = this.props;
        return (
            <div className={classes.weeklyMonthlyHeader}>
                <p>
                    Due to natural harvests, a specific date isn’t available. Please choose a {this.state.isMonthDatedCalendar ? 'month' : 'week'} below:
                </p>
            </div>
        );
    }

    // showSelectedMonthWeek = () => {
    //     const { classes } = this.props;
    //     const { activeMonth, activeWeek } = this.state;
    //     let fullDate;
    //     if (activeMonth) {
    //         // regex - replace hypen to slash eg - "2020-10-10" to "2020/10/10"
    //         fullDate = new Date(activeMonth.replace(/-/g, '/'));
    //     } else if (activeWeek) {
    //         // regex - replace hypen to slash eg - "2020-10-10" to "2020/10/10"
    //         fullDate = new Date(activeWeek.replace(/-/g, '/'));
    //     }
    //     const date = fullDate.getDate();
    //     const month = fullDate.getMonth();
    //     const year = fullDate.getFullYear();
    //     const getFullMonth = CalendarUtility.MonthsFull[month];
    //     const getShortMonth = CalendarUtility.MonthShort[month];
    //     let ShowArrivalMessage;
    //     if (activeMonth) {
    //         ShowArrivalMessage = <p className={classes.monthlyWeeklyText}>Your package will arrive in {getFullMonth} {year}</p>;
    //     } else if (activeWeek) {
    //         ShowArrivalMessage = <p className={classes.monthlyWeeklyText}>Your package will arrive in Week of {getShortMonth} {date} {year}</p>;
    //     }
    //     return (
    //         <div>
    //             {ShowArrivalMessage}
    //         </div>
    //     );
    // }

    overWriteDateComponent = (day, selectedDates, onSelectedDate, index, rootClasses) => {
        const {
            classes, brand, isPassportUser, passportSubscriptionStatus, shopRunnerLoggedIn,
        } = this.props;
        if (day) {
            const keyDay = `dayIndex${index}_${day.date}`;
            const dateDetails = this.deliveryDate[day.date];
            let upchargeStyle = classes.pricePerDay;
            let isEnabledBtn = false;
            let styleBtn = ''; // disabled button style
            let firstDaySelected = ''; // first button selected style
            let lastDaySelected = ''; // last button selected style
            let upCharge = '';
            const isHoliday = (this.holidayDateCollection.indexOf(day.date) >= 0);

            if (dateDetails) {
                isEnabledBtn = true;
                const totalCharges = (parseFloat(dateDetails[0].upcharge || 0, 10)) + (parseFloat(dateDetails[0].surcharge || 0, 10));
                if (totalCharges > 0) {
                    upCharge = `+$${totalCharges.toFixed(2)}`;
                }
            }

            // Free Shipping
            if (!upCharge && (isPassportUser || passportSubscriptionStatus || shopRunnerLoggedIn)) {
                upCharge = 'Free';
            }

            const holidayBtnStyle = (isHoliday) ? classes.holidayBtnStyle : '';
            const brandStyle = this.getButtonStyleForBrandSpecific(brand, classes);

            if (selectedDates.indexOf(day.date) < 0 && upCharge && upCharge !== 'Free') { // charges displayed and date unselected
                styleBtn = `${brandStyle.upChargeBtn} ${holidayBtnStyle}`;
            } else if (selectedDates.indexOf(day.date) >= 0 && upCharge && upCharge !== 'Free') { // charges displayed and date selected
                styleBtn = brandStyle.selectedUpChargeBtn;
                upchargeStyle = classes.pricePerDaySelected;
            } else if (selectedDates.indexOf(day.date) < 0 && upCharge && upCharge === 'Free') { // charges displayed and date unselected
                styleBtn = `${classes.freeDelivery} ${holidayBtnStyle}`;
            } else if (selectedDates.indexOf(day.date) >= 0 && upCharge && upCharge === 'Free') { // charges displayed and date selected
                styleBtn = classes.selectedFreeBtn;
                upchargeStyle = classes.pricePerDaySelected;
            } else if (selectedDates.indexOf(day.date) >= 0) { // date selected
                styleBtn = brandStyle.selectedBtn;
            } else if ((selectedDates.indexOf(day.date) < 0)) { // date unselected
                styleBtn = `${classes.unselectedBtn} ${holidayBtnStyle}`;
            }

            if (selectedDates.indexOf(day.date) === 0) {
                firstDaySelected = classes.firstSelectedBtn;
            }
            if (selectedDates.indexOf(day.date) === (selectedDates.length - 1)) {
                lastDaySelected = classes.lastSelectedBtn;
            }

            const dayDate = day.dateObj.getDate();

            return (
                <Grid item xs align="center" key={keyDay} className={`${styleBtn} ${(isEnabledBtn ? `button-enabled ${rootClasses?.root}` : `button-disabled ${rootClasses?.disable}`)} ${firstDaySelected} ${lastDaySelected}  ${rootClasses?.disable ? classes.disabledHover : ''}`}>
                    <Typography key={index} className={classes.dayOfTheWeek}>
                        {isEnabledBtn && (
                            <Button onClick={() => { onSelectedDate(day.dateObj); }}>
                                <div>{dayDate}{isHoliday && <sup>*</sup>}</div>
                                {upCharge && (
                                    <div className={upchargeStyle}>
                                        <div className={classes.chargeTextStyle}>{upCharge}</div>
                                    </div>
                                )}
                            </Button>
                        )}
                        {!isEnabledBtn
                            && (
                                <Button disabled className={classes.disabledBtn}>
                                    <div>{dayDate}{isHoliday && <sup>*</sup>}</div>
                                </Button>
                            )}
                    </Typography>
                </Grid>
            );
        }

        const keyDay = `dayDisabled${index + Math.random()}`;
        return (
            <Grid item xs align="center" key={keyDay} className={rootClasses?.disable}>
                {/* PAST DATE - SHOW EMPTY BOX */}
                <Typography key={index} className={classes.dayOfTheWeek}>
                    <Button disabled className={classes.disabledBtn}>&nbsp;</Button>
                </Typography>
            </Grid>
        );
    }

    returnApplyDate = () => {
        const { updateDeliveryDate, handleAreYouSureCloseCalendar } = this.props;
        const {
            selectedDeliveryDate, forceExactDay, selectedDateAnHoliday, holidaySelected, calendarResponse,
        } = this.state;

        let calendarDateChanged = false;
        const curSelectedDate = selectedDeliveryDate?.deliveryDate || '';

        if (curSelectedDate !== '' && this.selectedDate !== curSelectedDate) {
            calendarDateChanged = true;
        } else if ((holidaySelected !== '' && holidaySelected !== 'Choose Holiday') && this.savedDateHoliday !== holidaySelected) {
            calendarDateChanged = true;
        }

        if (calendarDateChanged) {
            updateDeliveryDate(
                selectedDeliveryDate,
                forceExactDay,
                selectedDateAnHoliday,
                holidaySelected,
                calendarResponse.guaranteedMethod,
            );
        } else {
            handleAreYouSureCloseCalendar(calendarDateChanged);
        }
    }

    handleCalendarClose = (event, reason) => {
        const {
            handleAreYouSureCloseCalendar,
        } = this.props;

        const { selectedDeliveryDate, holidaySelected } = this.state;

        let calendarDateChanged = false;
        const curSelectedDate = selectedDeliveryDate?.deliveryDate || '';

        if (curSelectedDate !== '' && this.selectedDate !== curSelectedDate) {
            calendarDateChanged = true;
        } else if ((holidaySelected !== '' && holidaySelected !== 'Choose Holiday') && this.savedDateHoliday !== holidaySelected) {
            calendarDateChanged = true;
        }

        handleAreYouSureCloseCalendar(calendarDateChanged);
    }

    render() {
        const {
            selectedDeliveryDate, selectedHoliday, calendarResponse,
            shipHolidayDetails, forceExactDay, selectedDateAnHoliday,
            holidaySelected, isMonthDatedCalendar, isWeekDatedCalendar,
            startDate, endDate, showLoader, selectedDateRange, calendarDisplayData,
            monthDatedData, activeMonth, weekDatedData, activeWeek, errorMessage,
        } = this.state;

        const {
            classes, brand, isOpen, flags,
            closeDeliveryCalModel, isPassportUser, passportSubscriptionStatus, shopRunnerLoggedIn,
            areYouSureCloseCalendar, closeAreYouSureMessage,
        } = this.props;
        const checkWidth = this.checkWidth();
        const isShowExactDay = (
            selectedDeliveryDate.calendarDateType === 'between'
            && calendarResponse.guaranteedCharge && calendarResponse.guaranteedCharge !== 'null'
        );

        return (
            <Dialog
                open={isOpen}
                onClose={this.handleCalendarClose}
                fullScreen
                classes={{
                    root: classes.deliveryCalendarDialogRoot,
                    paper: classes.deliveryCalendarDialogPaper,
                }}
            >
                {areYouSureCloseCalendar && (
                    <CloseCalendarConsent
                        closeModal={closeDeliveryCalModel}
                        saveDate={this.returnApplyDate}
                        closeAreYouSureMessage={closeAreYouSureMessage}
                    />
                )}
                <Grid id="delivery-food-calendar-v2" container>
                    <Grid item xs={12} className={classes.dialogHeader}>
                        <IconButton
                            color="inherit"
                            onClick={this.handleCalendarClose}
                            aria-label="Close"
                            data-test="checkout-delivery-calendar-close-button"
                            className={classes.dialogCloseIcon}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid container className={classes.calendarContainer}>
                        <Grid container alignContent="flex-start">
                            {
                                (errorMessage && endDate)
                                && (
                                    <Grid item xs={12}>
                                        <Button
                                            className={classes.prevButton}
                                            onClick={() => {
                                                this.callGoBackCallBack();
                                            }}
                                        >
                                            Go Back
                                        </Button>
                                    </Grid>
                                )
                            }
                            {
                                !!(startDate && endDate)
                                && (
                                    <>
                                        <Grid item xs={12}>
                                            <Grid container className={`${(isShowExactDay || calendarResponse.shipHolidays?.length > 0) && !errorMessage ? classes.containerTopCalendar : ''}`}>
                                                {
                                                    !errorMessage
                                                    && (
                                                        <>
                                                            <Grid item xs={7}>
                                                                <ExactDay
                                                                    calendarDateType={selectedDeliveryDate.calendarDateType}
                                                                    guaranteedCharge={calendarResponse.guaranteedCharge}
                                                                    forceExactDay={forceExactDay}
                                                                    onChangeForceExactDay={this.onChangeForceExactDay}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <ShipHolidaysList
                                                                    shipHolidays={calendarResponse.shipHolidays}
                                                                    holidaySelected={holidaySelected}
                                                                    onHolidaySelected={this.onHolidaySelected}
                                                                />
                                                            </Grid>
                                                        </>
                                                    )
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            {
                                                calendarDisplayData
                                                && Object.keys(calendarDisplayData).length > 0
                                                && !showLoader
                                                && (
                                                    <CalendarView
                                                        onClickCalNext={this.calNextCallBack}
                                                        onClickCalPrev={this.calPrevCallBack}
                                                        onSelectedDate={this.onSelectedDate}
                                                        overWriteDateComponent={this.overWriteDateComponent}
                                                        selectedDates={selectedDateRange}
                                                        calendarDisplayData={calendarDisplayData}
                                                        getMediumDayFormat={checkWidth.desktop}
                                                        getIconPlaceholder={checkWidth.desktop}
                                                    />
                                                )
                                            }
                                        </Grid>
                                    </>
                                )
                            }
                            {
                                isMonthDatedCalendar
                                && (
                                    <Grid item xs={12}>
                                        {
                                            showLoader === false && (
                                                <>
                                                    {this.monthlyWeeklyCalendarNotice()}
                                                    <MonthDatedCalendarView
                                                        isMonthActive={activeMonth}
                                                        getSelectedMonthDetails={this.getSelectedMonthDetails}
                                                        monthDatedData={(monthDatedData.length > 0) ? monthDatedData : []}
                                                        selectedDeliveryDate={selectedDeliveryDate}
                                                    />
                                                </>
                                            )
                                        }
                                    </Grid>
                                )
                            }
                            {
                                isWeekDatedCalendar
                                && (
                                    <Grid className={`${classes.gridStyle} ${classes.gridStylePadding}`} item>
                                        {
                                            !showLoader
                                            && (
                                                <>
                                                    {this.monthlyWeeklyCalendarNotice()}
                                                    <WeekDatedCalendarView
                                                        isWeekActive={activeWeek}
                                                        getSelectedWeekDetails={this.getSelectedWeekDetails}
                                                        selectedDeliveryDate={selectedDeliveryDate}
                                                        weekDatedData={(weekDatedData.length > 0) ? weekDatedData : []}
                                                    />
                                                </>
                                            )
                                        }
                                    </Grid>
                                )
                            }
                            {
                                (errorMessage)
                                && (
                                    <Grid item xs={12}>
                                        <Grid container className={classes.errorInfo}>
                                            <ErrorMessage error={errorMessage} noShadow />
                                        </Grid>
                                    </Grid>
                                )
                            }
                            {
                                showLoader && !errorMessage && <div className={classes.calendarLoader} />
                            }
                            {
                                !startDate && !endDate
                                && !errorMessage && !isMonthDatedCalendar
                                && !isWeekDatedCalendar
                                && (
                                    <div className={classes.calendarLoader}>
                                        Loading....
                                    </div>
                                )
                            }
                        </Grid>
                    </Grid>
                    {
                        calendarResponse?.calendarDates?.length > 0
                        || isWeekDatedCalendar
                        || isMonthDatedCalendar
                            ? (
                                <FoodArrivalDetails
                                    applyDateCallBack={this.returnApplyDate}
                                    errorMessage={errorMessage}
                                    forceExactDay={forceExactDay}
                                    isMonthDatedCalendar={isMonthDatedCalendar}
                                    isPassportUser={isPassportUser}
                                    isWeekDatedCalendar={isWeekDatedCalendar}
                                    isUseCalendarDateTypeByEnabled={flags['is-calendar-date-type-by-enabled']}
                                    passportSubscriptionStatus={passportSubscriptionStatus}
                                    selectedHoliday={selectedHoliday}
                                    selectedDeliveryDate={selectedDeliveryDate}
                                    shipHolidayDetails={shipHolidayDetails}
                                    shopRunnerLoggedIn={shopRunnerLoggedIn}
                                />
                            ) : null
                    }
                </Grid>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => ({
    flags: commonSelectors.getFlags(state),
    isPassportUser: getIsPassportUserLoggedIn(state),
    brand: commonSelectors.getBrand(state),
    passportSubscriptionStatus: getPassportSubscriptionStatus(state),
    shopRunnerLoggedIn: getShopRunnerToken(state),
    orderId: commonSelectors.getOrderId(state),
});

DeliveryFoodCalendarV2.propTypes = {
    auth: PropTypes.shape({
        getAccessTokenSafely: PropTypes.func.isRequired,
    }).isRequired,
    brand: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    closeDeliveryCalModel: PropTypes.func.isRequired,
    deliveryTextData: PropTypes.shape({
        deliveryHeaderTitle: PropTypes.string,
        deliveryHeaderCaption: PropTypes.string,
    }),
    flags: PropTypes.object.isRequired,
    flagOffShowLoadingMessage: PropTypes.func.isRequired,
    isPassportUser: PropTypes.bool.isRequired,
    orderItemId: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    orderItem: PropTypes.object,
    passportSubscriptionStatus: PropTypes.bool.isRequired,
    updateDeliveryDate: PropTypes.func.isRequired,
    updateShowLoadingMessage: PropTypes.func.isRequired,
    selectedDate: PropTypes.string.isRequired,
    shopRunnerLoggedIn: PropTypes.string,
    width: PropTypes.oneOf(['lg', 'md', 'sm', 'xl', 'xs']).isRequired,
    zipCode: PropTypes.string.isRequired,
    handleAreYouSureCloseCalendar: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    areYouSureCloseCalendar: PropTypes.bool.isRequired,
    closeAreYouSureMessage: PropTypes.func.isRequired,
};

DeliveryFoodCalendarV2.defaultProps = {
    shopRunnerLoggedIn: '',
    deliveryTextData: {
        deliveryHeaderTitle: '',
        deliveryHeaderCaption: '',
    },
    orderItem: {},
};

const enhance = compose(
    connect(mapStateToProps),
    withStyles(styles),
    withRouter,
    withWidth(),
    withAuth,
);

export default enhance(DeliveryFoodCalendarV2);
